module.exports = __webpack_public_path__ + "img/icon-illustration-theme.8a298319.svg";